import {
    QueryParametersAppState,
    SupportedQueryParameters,
} from './getAppStateFromQueryParameters'

export function getQueryParametersFromAppState(
    appState: QueryParametersAppState
): SupportedQueryParameters {
    const queryParameters = {
        scoreId: appState.scoreId,
        customerId: appState.customerId,
        // category: appState.category,
        sortKey: appState.sortKey,

        loanAmount: appState.scoreId == null ? `${appState.loanAmount}` : null,
        loanTerm: appState.scoreId == null ? `${appState.loanTerm}` : null,
        loanPurpose: appState.loanPurpose,
        loanId: appState.loanId,

        cam: appState.campaign,
        gclid: appState.googleClickId,
        k: appState.keyword,
        m: appState.mediaSource,
        adg: appState.adgroup,
        sendId: appState.sendId,

        mockId: appState.mockId,
    } as const

    return Object.keys(queryParameters).reduce((all, queryKey) => {
        const qk = queryKey as keyof typeof queryParameters

        if (queryParameters[qk] != null) {
            all[qk] = queryParameters[qk]!
        }
        return all
    }, {} as Record<string, string>)
}
